module.exports = __webpack_public_path__ + "static/img/3.1fd349b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/4/1/sp/3.png
// module id = qJTw
// module chunks = 0